/** Тариф ученика, использование и выбор тарифа «после беты». */

import type { AdBonusType, AdBonusView, BillingView, PlanIntentInput } from '@aptile/shared';

import { apiRequest, jsonBody } from './client';

export function fetchBilling(): Promise<BillingView> {
  return apiRequest<BillingView>('/api/billing');
}

export function sendPlanIntent(input: PlanIntentInput): Promise<BillingView> {
  return apiRequest<BillingView>('/api/billing/intent', { method: 'POST', body: jsonBody(input) });
}

/** Реклама досмотрена: лимит урока, разговора с Тико или игр растёт. */
export function claimAdBonus(bonusType: AdBonusType): Promise<AdBonusView> {
  return apiRequest<AdBonusView>('/api/billing/ad-bonus', { method: 'POST', body: jsonBody({ bonusType }) });
}
